<template>
    <v-app>
        <v-main class="pt-0">
            <v-parallax class="mb-6 hero-parallax" dark src="@/assets/img/hcl-hero-new.png" height="450">
                <v-row align="center" justify="end">
                    <v-col cols="12" md="6" sm="12">
                        <v-row align="center" justify="center">
                            <v-col cols="12" sm="12" md="12" class="white--text text-center">
                                <v-img :src="heroImage" max-width="150px" class="d-block ml-auto mr-auto"></v-img>
                                <h1 v-if="heroImage != null" class="font-weight-light display-2 mb-8">{{
                                    $route.params.pathMatch.toUpperCase() }}</h1>
                                <h1 v-if="$route.query.vendor != undefined" class="font-weight-light display-2 mb-8">
                                    {{ $route.query.vendor.toUpperCase() }}
                                </h1>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-parallax>
            <v-row justify="start">
                <v-btn class="ma-2 ml-16" size="x-large" color="#041a41" @click="goToHome">
                    <v-icon color="white" left>mdi-arrow-left
                    </v-icon>
                    <h3 style="color: white;">Voltar Para Pagina Inicial</h3>
                </v-btn>
            </v-row>

            <v-row align="center" justify="center">
                <v-col cols="10">


                    <v-row align="center" justify="center">
                        <v-col cols="12" sm="10" md="8" lg="6">
                            <v-card class="mt-12 mb-12">
                                <v-toolbar flat>
                                    <v-text-field v-model="searchTerm" label="Busque modelos certificados" min-width="500"
                                        hide-details="auto" @keypress.enter="searchModels"></v-text-field>
                                    <v-btn icon @click="searchModels">
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </v-toolbar>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-card class="mt-12">
                        <v-card-title class="justify-start">Total de Modelos: {{ totalCount }}</v-card-title>
                        <v-card-text>
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left">Fornecedor</th>
                                            <th class="text-left">Modelo</th>
                                            <th class="text-left">Plataforma</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <div v-if="loading">Loading...</div>
                                        <tr v-else v-for="model in models.data" :key="model.id">
                                            <td class="text-left">
                                                <router-link :to="`/certificados/?vendor=${model.Manufacturer}&page=1`">
                                                    {{ model.Manufacturer }}
                                                </router-link>
                                            </td>
                                            <td class="text-left">
                                                <router-link :to="`/certificado/${model.ID}`" >
                                                    {{ model.Model }}
                                                </router-link>
                                            </td>
                                            <td class="text-left">{{ model.Platform }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <div class="text-center">
                <v-pagination v-model="page" :length="total" rounded="circle" @input="updatePage"></v-pagination>
            </div>
        </v-main>
        <footerSection />
    </v-app>
</template>

<script>
import axios from '@/utils/axios';
import footerSection from "@/components/Footer";
export default {
    components: {
        footerSection
    },
    watch: {
        '$route'() {
            // Verifique se a chamada para fetchModels já está em andamento
            if (!this.loading) {
                this.vendor = this.$route.query.vendor ? this.$route.query.vendor : undefined;
                this.search = this.$route.query.search ? this.$route.query.search : undefined;
                this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1;
                this.fetchModels();
            }
        }
    },
    data() {
        return {
            models: [],
            loading: false,
            error: null,
            page: 1,
            total: 1,
            totalCount: 1,
            heroImage: null,
            searchTerm: "",
            vendor: undefined,
            search: undefined
        };
    },
    created() {
        this.vendor = this.$route.query.vendor ? this.$route.query.vendor : undefined;
        this.search = this.$route.query.search ? this.$route.query.search : undefined;

        if (this.vendor == undefined && this.search == undefined) {
            this.heroImage = require(`@/assets/img/${this.$route.params.pathMatch}.png`)
        }
        this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1;
        this.fetchModels();
    },
    methods: {
        updatePage(page) {
            this.$router.push({
                path: this.$route.path,
                query: { vendor: this.vendor, page: page, search:this.search }
            });
        },
        searchModels() {
            const searchUrl = `/certificados/busca/?search=${this.searchTerm}&page=${this.page}`;
            this.$router.push(searchUrl);
        },
        goToHome() {
            const home = `/`;
            this.$router.push(home);
        },
        async navigateWithQuery(vendor) {
            this.vendor = vendor;
            await this.fetchModels();
            this.$router.push({ path: '/certificados', query: { vendor: this.vendor } });
        },
        async fetchModels() {
            if (this.abortController && this.abortController.signal.aborted) {
                return;
            }
            this.loading = true;
            try {
                let response;
                if(this.$route.params.pathMatch != "busca/"){
                    response = await axios.get(`api/getModel.php?platform=${this.$route.params.pathMatch}&page=${this.page}`);
                }
                if (this.vendor != undefined) {
                    response = await axios.get(`api/getVendor.php?manufacturer=${this.vendor}&page=${this.page}`);
                }
                if (this.search != undefined) {
                    response = await axios.get(`api/getSearch.php?&search=${this.search}&page=${this.page}`);
                }
                this.models = response.data;
                this.total = response.data.totalPages;
                this.totalCount = response.data.totalCount;
            } catch (error) {
                console.error('Error:', error);
                this.error = error.message;
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>
